module.exports = "/_next/static/images/percentage-monotone-6b9e6a7e65206bc48c2061bc2c5a1d10.svg";